module.exports = __webpack_public_path__ + "img/service-1.d5945c86.svg";